var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSequentialCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6814 41.2039L74.0002 40.9192L46 16V58.3654L73.6814 41.2039Z",
    fill: "#7551D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0002 16.0009V16L18 40.92L18.3196 41.2047L46.0002 58.3662V16.0009Z",
    fill: "#CFBCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.207 40.9121L18.1738 41.1155L46.0002 58.367L73.8275 41.1155L73.6407 40.8125L18.207 40.9121Z",
    fill: "#234659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.014 39.2344H21.5879V61.4305H71.014V39.2344Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 43.2656H27.9375V44.2071H64.5145V43.2656Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 45.4844H27.9375V46.4267H64.5145V45.4844Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 47.707H27.9375V48.6485H64.5145V47.707Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 49.9258H27.9375V50.8681H64.5145V49.9258Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 52.1484H27.9375V53.0899H64.5145V52.1484Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 54.3633H27.9375V55.3056H64.5145V54.3633Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5145 56.5859H27.9375V57.5274H64.5145V56.5859Z",
    fill: "#BCB0A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6814 41.2032L46 58.3647V65.8386V74.6599H73.8273V41.1133L73.6814 41.2032Z",
    fill: "#7551D0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3197 41.2032L18.1738 41.1133L18.3197 74.6599H46.0002V65.8386V58.3647L18.3197 41.2032Z",
    fill: "#CFBCFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8275 41.1133C68.9641 43.6808 64.2089 46.3872 59.4895 49.1425C54.957 51.7913 50.4594 54.4872 46.0002 57.2303C41.5411 54.4872 37.0444 51.7913 32.5119 49.1425C27.7925 46.3872 23.0364 43.68 18.1738 41.1133C22.5849 44.2616 27.1052 47.2728 31.6613 50.2342C35.8506 52.9563 40.0757 55.6313 44.3322 58.2661C44.8152 58.549 45.6439 59.1228 45.9994 59.2983C46.2264 59.1988 47.0543 58.6224 47.6692 58.2661C51.9257 55.6304 56.1508 52.9554 60.3401 50.2342C64.897 47.2728 69.4164 44.2607 73.8275 41.1133Z",
    fill: "#234659"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6814 36.2039L68.0002 35.9192L40 11V53.3654L67.6814 36.2039Z",
    fill: "#7551D0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 11.0009V11L12 35.92L12.3196 36.2047L40.0002 53.3662V11.0009Z",
    fill: "#CFBCFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.207 35.9121L12.1738 36.1155L40.0002 53.367L67.8275 36.1155L67.6407 35.8125L12.207 35.9121Z",
    fill: "#234659"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.014 34.2344H15.5879V56.4305H65.014V34.2344Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 38.2656H21.9375V39.2071H58.5145V38.2656Z",
    fill: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 40.4844H21.9375V41.4267H58.5145V40.4844Z",
    fill: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 42.707H21.9375V43.6485H58.5145V42.707Z",
    fill: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 44.9258H21.9375V45.8681H58.5145V44.9258Z",
    fill: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 47.1484H21.9375V48.0899H58.5145V47.1484Z",
    fill: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 49.3633H21.9375V50.3056H58.5145V49.3633Z",
    fill: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5145 51.5859H21.9375V52.5274H58.5145V51.5859Z",
    fill: "#BCB0A0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6814 36.2032L40 53.3647V60.8386V69.6599H67.8273V36.1133L67.6814 36.2032Z",
    fill: "#7551D0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3197 36.2032L12.1738 36.1133L12.3197 69.6599H40.0002V60.8386V53.3647L12.3197 36.2032Z",
    fill: "#CFBCFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8275 36.1133C62.9641 38.6808 58.2089 41.3872 53.4895 44.1425C48.957 46.7913 44.4594 49.4872 40.0002 52.2303C35.5411 49.4872 31.0444 46.7913 26.5119 44.1425C21.7925 41.3872 17.0364 38.68 12.1738 36.1133C16.5849 39.2616 21.1052 42.2728 25.6613 45.2342C29.8506 47.9563 34.0757 50.6313 38.3322 53.2661C38.8152 53.549 39.6439 54.1228 39.9994 54.2983C40.2264 54.1988 41.0543 53.6224 41.6692 53.2661C45.9257 50.6304 50.1508 47.9554 54.3401 45.2342C58.897 42.2728 63.4164 39.2607 67.8275 36.1133Z",
    fill: "#234659"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6814 30.2039L61.0002 29.9192L33 5V47.3654L60.6814 30.2039Z",
    fill: "#7551D0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0002 5.00087V5L5 29.92L5.31963 30.2047L33.0002 47.3662V5.00087Z",
    fill: "#CFBCFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20701 29.9121L5.17383 30.1155L33.0002 47.367L60.8275 30.1155L60.6407 29.8125L5.20701 29.9121Z",
    fill: "#234659"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M58.014 28.2344H8.58789V50.4305H58.014V28.2344Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 32.2656H14.9375V33.2071H51.5145V32.2656Z",
    fill: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 34.4844H14.9375V35.4267H51.5145V34.4844Z",
    fill: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 36.707H14.9375V37.6485H51.5145V36.707Z",
    fill: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 38.9258H14.9375V39.8681H51.5145V38.9258Z",
    fill: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 41.1484H14.9375V42.0899H51.5145V41.1484Z",
    fill: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 43.3633H14.9375V44.3056H51.5145V43.3633Z",
    fill: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5145 45.5859H14.9375V46.5274H51.5145V45.5859Z",
    fill: "#BCB0A0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6814 30.2032L33 47.3647V54.8386V63.6599H60.8273V30.1133L60.6814 30.2032Z",
    fill: "#7551D0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31967 30.2032L5.17383 30.1133L5.31967 63.6599H33.0002V54.8386V47.3647L5.31967 30.2032Z",
    fill: "#CFBCFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8275 30.1133C55.9641 32.6808 51.2089 35.3872 46.4895 38.1425C41.957 40.7913 37.4594 43.4872 33.0002 46.2303C28.5411 43.4872 24.0444 40.7913 19.5119 38.1425C14.7925 35.3872 10.0364 32.68 5.17383 30.1133C9.58494 33.2616 14.1052 36.2728 18.6613 39.2342C22.8506 41.9563 27.0757 44.6313 31.3322 47.2661C31.8152 47.549 32.6439 48.1228 32.9994 48.2983C33.2264 48.1988 34.0543 47.6224 34.6692 47.2661C38.9257 44.6304 43.1508 41.9554 47.3401 39.2342C51.897 36.2728 56.4164 33.2607 60.8275 30.1133Z",
    fill: "#234659"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9 65H62V26",
    stroke: "#F4F1FC",
    strokeWidth: 3
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9 71H69V26",
    stroke: "#F4F1FC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequentialCampaign);
export default __webpack_public_path__ + "static/media/sequential-campaign.c788903660b807ba7501cafeeb623f1b.svg";
export { ForwardRef as ReactComponent };